<template>
    <div class="images_swiper">
        <swiper ref="swiper" :options="Options" 
        @click-slide="slideTap">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item.image});`">
                        <!-- <img :src="item.image" alt=""> -->
                        <img src="../assets/images/icon_video_play.png" alt="" class="icon" v-if="item.type == 2">
                    </div>
                    <div class="text">{{item[lange('name')]}}</div>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: "imagesSwiper",
    props: ['data'],
    data() {
        return {
            Options: {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                navigation: {
                    nextEl: '.images_swiper .swiper-button-next',
                    prevEl: '.images_swiper .swiper-button-prev',
                },
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.$swiper
        },
        lange(){
            return (name)=>{
                if(this.$i18n.locale == 'en'){
                    return `en_${name}`
                }else{
                    return name
                }
            }
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive
    },
    mounted() {},
    watch: {
        data(){
            this.swiper.slideTo(0, 0);
        }
    },
    methods: {
        slideTap(index){
            this.$emit('slideTap', index);
        },
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.images_swiper{
    margin: .25rem 0;
    padding: 0 .3rem;
    position: relative;
    .swiper-slide{
        width: 1.5rem;
        margin-right: .12rem;
        cursor: pointer;
        &:last-child{
            margin-right: 0;
        }
        .cover{
            height: 1rem;
            border-radius: .04rem;
            margin-bottom: .1rem;
            overflow: hidden;
            position: relative;
            background-repeat: no-repeat;
            background-size: cover;
            .icon{
                width: .4rem;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .text{
            color: #fff;
            font-size: .14rem;
            text-align: center;
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .30rem;
        height: .30rem;
        top: .35rem;
        margin-top: 0;
        background: no-repeat center/.15rem;
        &::after{
            display: none;
        }
    }
    .swiper-button-prev{
        left: 0;
        background-image: url('../assets/images/icon_checked_item_arrow_prev.png');
    }
    .swiper-button-next{
        right: 0;
        background-image: url('../assets/images/icon_checked_item_arrow_next.png');
    }
}
</style>